import { useFeedback26CoStore } from '@/stores/feedback-26-co';
import { useFeedbackEdition } from '../edition-context';
import { NumericRating } from './NumericRating';

export function Aura() {
  const { formData, setAuraRating } = useFeedback26CoStore();
  const { eventName } = useFeedbackEdition();

  return (
    <div className="space-y-10">
      <div>
        <h2 className="mb-2 font-bold text-2xl">AURA</h2>
        <p className="text-muted-foreground">Una última pregunta.</p>
      </div>

      <div className="space-y-4">
        <p className="block font-semibold">
          ¿Cuánta AURA consideras que tuvo {eventName}?{' '}
          <span className="text-destructive">*</span>
        </p>
        <NumericRating
          value={formData.auraRating}
          onChange={setAuraRating}
          options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
          leftLabel="Nada de aura"
          rightLabel="Aura infinita"
        />
      </div>
    </div>
  );
}
